
import Vue from 'vue'
import App from './App.vue'
import AppB from './AppB.vue'
import AppC from './AppC.vue'
import AppD from './AppD.vue'
import AppE from './AppE.vue'
import AppF from './AppF.vue'
import router from './router'
import routerB from './router/routerB'
import routerC from './router/routerC'
import routerD from './router/routerD'
import routerE from './router/routerE'
import routerF from './router/routerF'
import i18n from "./i18n.js"
import Antd from 'ant-design-vue';
import '@/assets/js/http'
import 'ant-design-vue/dist/antd.css'
import store from './store';
import env from '@/assets/js/env'

Vue.use(Antd);

const globalData = Vue.observable({
  lang: 'en', // 默认语言为英文
});

Vue.prototype.$global = globalData; // 将可响应对象存储在全局变量中
Vue.config.productionTip = false

if (localStorage.lang !== undefined) {
  i18n.locale =  localStorage.getItem('lang')
} else {
  localStorage.setItem("lang", "en-US")
  i18n.locale = localStorage.getItem('lang')
}

const initVueInstance = (router, RootApp) => {
  new Vue({
    router,
    i18n,
    store,
    render: h => h(RootApp),
  }).$mount('#app')
}

// 品牌（含皮肤、favicon）由 env.js 按域名从 runtime-env.js 里选好
const styleType = String(env.styleType || 'A').toUpperCase();

const updateFavicon = (iconFile) => {
  const favicon = document.querySelector("link[rel~='icon']");

  if (favicon && iconFile) {
    favicon.href = `${process.env.BASE_URL}${iconFile}`;
  }
}

updateFavicon(env.favicon);

if (styleType === 'B') {
  initVueInstance(routerB, AppB);
} else if (styleType === 'C') {
  initVueInstance(routerC, AppC);
} else if (styleType === 'D') {
  initVueInstance(routerD, AppD);
} else if (styleType === 'E') {
  initVueInstance(routerE, AppE);
} else if (styleType === 'F') {
  initVueInstance(routerF, AppF);
} else {
  initVueInstance(router, App);
}
